import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const EMPTY = { items: [], matching_ids: [], total: 0, available_count: null, brands: [], categories: [], no_brand_count: 0 };

export const useAvailableProducts = ({ enabled, query, brand, category, sort, pageSize, revision }) => {
  const [result, setResult] = useState({ key: "", request: "", data: EMPTY, error: "" });
  const key = JSON.stringify([query.trim(), brand, category, sort, revision]);
  const request = `${key}:${pageSize}`;
  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        // Re-fetch the requested pages together after a mutation as well, so an
        // old page cannot survive a visibility/stock update or overwrite a query.
        const responses = await Promise.all(Array.from({ length: Math.ceil(pageSize / 60) }, (_, page) =>
          axios.get(`${API}/admin/products/available-search`, { withCredentials: true,
            signal: controller.signal, params: { q: query.trim(), brand, category, sort, offset: page * 60, limit: 60 } })));
        if (controller.signal.aborted) return;
        const rows = new Map(responses.flatMap(r => r.data.items).map(p => [p.id, p]));
        setResult({ key, request, error: "", data: { ...responses[0].data, items: [...rows.values()] } });
      } catch (e) {
        if (controller.signal.aborted) return;
        setResult({ key, request, data: EMPTY, error: typeof e.response?.data?.detail === "string"
          ? e.response.data.detail : "Не удалось загрузить товары. Повторите поиск." });
      }
    }, 220);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [enabled, key, request, query, brand, category, sort, pageSize]);
  const current = result.key === key;
  return { ...(current ? result.data : { ...EMPTY, available_count: result.data.available_count, brands: result.data.brands, categories: result.data.categories, no_brand_count: result.data.no_brand_count }),
    loading: enabled && result.request !== request, error: current ? result.error : "" };
};